import React, { useContext , useEffect, useRef, useState } from "react";
import styles from './Catalogue.module.css';
import generalStyles from '../generalAssets/GeneralAssets.module.css';
import buttonStyles from '../../buttons/Buttons.module.css';
import { BrandCountryContext } from "../../providers/BrandCountryProvider";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { QuoteBasketContext } from "../../providers/QuoteBasketProvider";
import ProductCardV3 from "./ProductCardV3";
import { displayCommas, numberTo2sf } from "../../../functions/NumericalFunctions";

export default function QuoteBasket(){

    const { setDisable , handlePageChange } = useContext(BrandCountryContext);
    const { basketArray } = useContext(QuoteBasketContext);

    const navigate = useNavigate();

    const [basketProducts,setBasketProducts] = useState([]);

    useEffect(() => {
        handlePageChange(window.location.pathname);
        getCatalogueItems();
    },[]);

    const getCatalogueItems = async () => {
        const headers = new Headers();
        headers.append('Content-Type','application/x-www-form-urlencoded');
        fetch(`${process.env.REACT_APP_STATUS === 'PRODUCTION'? process.env.REACT_APP_PRODUCTION_BACKEND : process.env.REACT_APP_BACKEND}/catalogue/idArray/8/${JSON.stringify(basketArray.map((item) => item.id))}`,{
            method: 'GET',
            headers: headers,
            credentials: 'include',
        })
        .then((res) => res.text())
        .then((data) => {
            const recObj = JSON.parse(data);
            console.log(recObj.catalogueItems[0]);
            setBasketProducts(recObj.catalogueItems);
        })
        .catch((err) => console.log(err));
    }

    useEffect(() => {
        console.log(basketProducts);
    },[basketProducts]);

    return(
        <div className={generalStyles.container} >
            <div className={styles.mobileCon}>
                <div className={styles.navigation}>
                    <Link to="/hiq/catalogue">Back to Catalogue</Link>
                </div>
                <p className={styles.subHeading}>Your Quote Basket</p>
                {/* <div className={styles.productCardContainer}> */}
                    {basketProducts.length > 0 && basketArray.length > 0? basketArray.map((basketItem,index) => <div className={styles.outerCard}><ProductCardV3 key={basketItem.id} basketItem={basketItem} productArray={basketProducts}/><hr style={{display: `${basketProducts.length - 1 === index? 'block' : 'block'}`}}/></div>) : <div className={styles.noProducts}>No Products</div>}
                {/* </div> */}
                <div className={styles.productTotal}>
                    <p className={styles.subtotalCost}>Product Subtotal (Estimated)</p>
                    <p className={styles.subtotalCost}>
                        £{displayCommas(numberTo2sf(basketProducts.map((product) => {
                            const index = basketArray.findIndex((basketItem) => basketItem.id === product.id);
                            if(index > -1){
                                return {
                                    ...product,
                                    subTotal: basketArray[index].qty*product.stratelaSalesCost
                                };
                            } else {
                                return {
                                    ...product,
                                    subTotal: 0
                                };
                            }
                        }).reduce((acc,item) => acc + Number(numberTo2sf(item.subTotal)) , 0)))}
                    </p>
                </div>
                <div className={styles.productTotal}>
                    <p className={styles.subtotalCost}>Delivery Subtotal</p>
                    <p className={styles.subtotalCost}>
                        £ TBC
                    </p>
                </div>
                <div className={styles.submitContainer}>
                    <button className={buttonStyles.submitStyleHiQ} onClick={() => navigate('/hiq/quoteSubmit')}>Proceed to Quote Request</button>
                </div>
            </div>
        </div>
    )
}